<template>
    <div>
      <section class="fixed-page w-100 d-block text-center container container-tranparencia-editor-js">
        <EditorJs v-if="entry" :object="entry.body" />
      </section>  
    </div>
  </template>
  
  <script>
    import { contentStore } from '@/stores/contents';
    import EditorJs from "@/components/Global/editorJs.vue"
    export default {
      name: "FixedPage",
      props: {
        contentforSlug: {
          type: [String, Boolean],
          default: false,
        },
      },
      components: {
        EditorJs
      },
      setup() {
        const store = contentStore();
        return {
          store
        }
      },
      mounted() {
        this.loadFixedPage();
      },
      watch: {
        $route() {
          this.loadFixedPage();
        },
        contentforSlug() {
          this.loadFixedPage();
        },
      },
      methods: {
        resolveSlug() {
          if (typeof this.contentforSlug === "string" && this.contentforSlug.length > 0) {
            return this.contentforSlug;
          }
          if (this.contentforSlug === true) {
            return this.$route.path.replace('/', '');
          }
          return this.$route.path.replace('/', '');
        },
        loadFixedPage() {
          this.store.loadPageFixed({
            slug: this.resolveSlug(),
          }).catch(() => {
            this.$router.replace('/');
          });
        },
      },
      computed: {
        entry() {
          return this.store.getPageFixed(this.resolveSlug())
        }
      }
    }
  </script>
  
  <style scoped lang="scss">
    @import "../styles/icons";
    @import "../styles/general";
  
    .black {
      color: black !important;
      margin-bottom: 0px !important;
    }
  </style>